export default __webpack_public_path__ + "static/bg-illustration-45a8248011740c5a67e3ae45cd4d4314.svg";